/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { useState, useEffect } from 'react';

export function useCustomBreakpoint(minWidth: number): boolean {
  const [matches, setMatches] = useState(() => (typeof window !== 'undefined' ? window.innerWidth >= minWidth : false));

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(min-width: ${minWidth}px)`);
    setMatches(mediaQuery.matches);

    const handler = (event: MediaQueryListEvent) => setMatches(event.matches);
    mediaQuery.addEventListener('change', handler);

    return () => mediaQuery.removeEventListener('change', handler);
  }, [minWidth]);

  return matches;
}
